export default __webpack_public_path__ + "static/media/ville-kaisla-HNCSCpWrVJA-unsplash.4fdabbad.jpg";